import { render, staticRenderFns } from "./createNewInputButton.vue?vue&type=template&id=7330323b&scoped=true&"
import script from "./createNewInputButton.vue?vue&type=script&lang=js&"
export * from "./createNewInputButton.vue?vue&type=script&lang=js&"
import style0 from "./createNewInputButton.vue?vue&type=style&index=0&id=7330323b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330323b",
  null
  
)

export default component.exports